var _excluded = ["children", "disabled", "hideLabel", "alignItems", "flexGrow"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { display } from 'styled-system';
import { filterStyledSystemProps } from '../ComponentHelpers/index';
import { strictSpace } from '../../utils'; // shared checkbox and radio components and config

export var radioDiameter = 20;
export var transitionConfig = '.2s cubic-bezier(0.075, 0.82, 0.52, 1.405)';
export var StyledLabel = styled.label.withConfig({
  displayName: "SharedBaseComponents__StyledLabel",
  componentId: "sc-16t7j9b-0"
})(["display:flex;align-items:", ";flex-grow:", ";cursor:pointer;", " ", " > span{margin-right:", ";}", ""], function (_ref) {
  var alignItems = _ref.alignItems;
  return alignItems;
}, function (_ref2) {
  var flexGrow = _ref2.flexGrow;
  return flexGrow;
}, strictSpace, display, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.s;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && css(["cursor:not-allowed;"]);
});
StyledLabel.defaultProps = {
  my: 's',
  alignItems: 'center'
};
export var LabelText = styled.span.withConfig({
  displayName: "SharedBaseComponents__LabelText",
  componentId: "sc-16t7j9b-1"
})(["", ";", ""], function (_ref5) {
  var alignItems = _ref5.alignItems;
  return alignItems === 'top' && css(["position:relative;top:-1px;"]);
}, function (_ref6) {
  var hideLabel = _ref6.hideLabel;
  return hideLabel && css(["display:none;"]);
});
export var createSelector = function createSelector(InputComponent) {
  return function (_ref7) {
    var children = _ref7.children,
        disabled = _ref7.disabled,
        hideLabel = _ref7.hideLabel,
        alignItems = _ref7.alignItems,
        flexGrow = _ref7.flexGrow,
        rest = _objectWithoutProperties(_ref7, _excluded);

    var _filterStyledSystemPr = filterStyledSystemProps({
      props: rest,
      styledSystemFuncs: [strictSpace, display]
    }),
        _filterStyledSystemPr2 = _slicedToArray(_filterStyledSystemPr, 2),
        nonStyledSystemProps = _filterStyledSystemPr2[0],
        styledSystemProps = _filterStyledSystemPr2[1];

    return /*#__PURE__*/React.createElement(StyledLabel, _extends({}, styledSystemProps, {
      alignItems: alignItems,
      flexGrow: flexGrow,
      disabled: disabled
    }), /*#__PURE__*/React.createElement(InputComponent, _extends({}, nonStyledSystemProps, {
      disabled: disabled
    })), /*#__PURE__*/React.createElement(LabelText, {
      hideLabel: hideLabel,
      alignItems: alignItems
    }, children));
  };
};